import "react/jsx-runtime";
import "styled-components";
import { useThemeInMode as f } from "../../../../context/theme/hooks.js";
import "react";
import "../../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import C from "../../../../hooks/useResponsiveProp.js";
import k from "../../../../styles/colors/surfaces/useForegroundVariantColor.js";
import { colorWithDisabledOpacity as i } from "../../../../utils/colorWithOpacity/index.js";
const w = {
  small: "38px",
  medium: "45px"
};
function D({
  size: m,
  error: d,
  menuWidth: g = "100%",
  noInputBox: t
}) {
  const e = f(), u = k("1"), c = e.foreground, n = e["neutral-high-content"], s = e["neutral-medium-content"], l = d ? e["error-high-content"] : e["neutral-high-content"], h = {
    backgroundColor: u
  }, p = C(g);
  return {
    input: (o) => ({
      ...o,
      color: n,
      ":active": {
        border: t ? "none" : o.border
      },
      ":focus": {
        border: t ? "none" : o.border
      }
    }),
    loadingIndicator: (o) => ({
      ...o,
      color: n
    }),
    loadingMessage: (o) => ({
      ...o,
      color: n
    }),
    noOptionsMessage: (o) => ({
      ...o,
      color: n
    }),
    placeholder: (o, { isDisabled: r }) => ({
      ...o,
      color: r ? i(s) : s
    }),
    control: (o, { isDisabled: r, isFocused: a }) => ({
      ...o,
      height: w[m],
      backgroundColor: r ? i(c) : c,
      borderColor: r ? i(l) : l,
      ...a && {
        borderColor: e["primary-high-content"],
        border: t ? "none" : o.border
      },
      border: t ? "none" : o.border,
      background: t ? "transparent" : o.background,
      boxShadow: t ? "none" : o.boxShadow,
      ":hover": {
        borderColor: a ? e["primary-high-content"] : l,
        cursor: "pointer"
      }
    }),
    singleValue: (o, { isDisabled: r }) => ({
      ...o,
      color: r ? i(n) : n
    }),
    valueContainer: (o) => ({
      ...o,
      padding: t ? "0" : o.padding
    }),
    dropdownIndicator: (o, { isDisabled: r, selectProps: { menuIsOpen: a } }) => ({
      ...o,
      color: r ? i(n) : n,
      transition: "transform 0.2s ease",
      ...a && {
        transform: "rotate(180deg)"
      }
    }),
    option: (o, { isDisabled: r, isFocused: a, isSelected: b }) => ({
      ...o,
      backgroundColor: c,
      ...a && h,
      ...!r && {
        ":hover": { ...h, cursor: "pointer" }
      },
      color: b ? e["primary-high-content"] : e["neutral-high-content"]
    }),
    indicatorSeparator: () => ({}),
    menuList: (o) => ({
      ...o,
      maxHeight: "150px",
      backgroundColor: c
    }),
    menu: (o) => ({ ...o, width: p })
  };
}
export {
  D as default
};
